<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="售后编号：">
            <el-input v-model="query.orderNum" placeholder="请输入订单编号" clearable size="small" />
          </el-form-item>
          <el-form-item label="商品名称：">
            <el-input v-model="query.goodsName" placeholder="请输入商品名称" clearable size="small" />
          </el-form-item>
          <el-form-item label="姓名：">
            <el-input v-model="query.name" placeholder="请输入姓名" clearable size="small" />
          </el-form-item>
          <el-form-item label="手机号：">
            <el-input v-model="query.pho" placeholder="请输入手机号" clearable size="small" />
          </el-form-item>
          <el-form-item label="身份：">
            <el-select v-model="query.CLevel" placeholder="请选择" clearable size="small">
              <el-option :label="it.name" :value="it.level" v-for="it in fetchList" :key="it.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="快递单号：">
            <el-input v-model="query.deliveryInfo" placeholder="请输入快递单号" clearable size="small" />
          </el-form-item>
          <el-form-item label="售后驳回：">
            <el-select v-model="query.rejectState" placeholder="请选择" clearable size="small">
              <el-option label="全部" :value="-1"></el-option>
              <el-option label="平台驳回" :value="1"></el-option>
              <el-option label="未支付" :value="2"></el-option>
              <el-option label="未确认" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="活动商品：">
            <el-select v-model="query.isActivityAfter" placeholder="请选择" clearable size="small">
              <el-option label="活动商品" :value="1"></el-option>
              <el-option label="普通商品" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="提交来源：">
            <el-select v-model="query.source" placeholder="请选择" clearable size="small">
              <el-option label="APP用户提交" :value="1"></el-option>
              <el-option label="后台添加" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间筛选：">
            <el-select v-model="query.searchTimeType" placeholder="请选择" clearable size="small">
              <el-option label="申请时间" :value="1"></el-option>
              <el-option label="同意申请时间" :value="2"></el-option>
              <el-option label="寄回商品时间" :value="3"></el-option>
              <el-option label="售后处理时间" :value="4"></el-option>
              <el-option label="完成时间" :value="5"></el-option>
              <el-option label="驳回时间" :value="6"></el-option>
            </el-select>
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="客户所属省市区：">
            <!--
              REQ-2026-842631 多选省市区。
              collapse-tags：选多个时折叠成「+N」，不然筛选区会被标签撑开好几行
              show-all-levels=false：只显示最后一级，同 bigClient/list.vue
              checkStrictly：允许只选到省或只选到市
            -->
            <el-cascader v-model="addrPaths" :props="cascaderProps" collapse-tags :options="addressList"
              :show-all-levels="false" clearable placeholder="请选择省市区" size="small"></el-cascader>
          </el-form-item>
          <el-form-item class="fr">
            <!-- <el-button :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" round size="mini" @click="changeShow">{{ showMore ? "叠起" : "展开" }}</el-button> -->
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-box" style="text-align: right;">
        <el-button type="primary" size="mini" @click="handleExport" plain v-hasPermi="['order:afterorder:export']">导出</el-button>
        <!-- <el-dropdown @command="handleCommand" v-if="+activeName === 1" v-hasPermi="['order:afterorder:state']">
          <el-button type="primary" size="mini">批量操作<i class="el-icon--right el-icon-arrow-down"></i></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="beforeHandleCommand(row, 1)">批量同意</el-dropdown-item>
            <el-dropdown-item :command="beforeHandleCommand(row, 2)">批量驳回</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
      </div>
      <div class="btn-right-side mb10">
        <!-- -1-已取消，2-已申请/↳待寄回，3-寄回商品/↳待平台签收，31-平台签收/↳待平台处理，4-平台处理/↳待买家确认，5-买家确认/已完成，6-已终止 -->
        <el-tabs v-model="activeName" @tab-click="handleClick" v-if="afterSalesTotal">
          <!-- <el-tab-pane name="1"><span slot="label">待审核({{afterSalesTotal.audit}})</span></el-tab-pane> -->
          <el-tab-pane name="2"><span slot="label">待寄回商品({{afterSalesTotal.sentBack}})</span></el-tab-pane>
          <el-tab-pane name="3"><span slot="label">待收货({{afterSalesTotal.pendingReceipt}})</span></el-tab-pane>
          <el-tab-pane name="31"><span slot="label">待处理售后({{afterSalesTotal.waitHandling}})</span></el-tab-pane>
          <el-tab-pane name="41"><span slot="label">待大区审核({{afterSalesTotal.pendingRegional}})</span></el-tab-pane>
          <el-tab-pane name="42"><span slot="label">待尤总审核({{afterSalesTotal.pendingCeo}})</span></el-tab-pane>
          <el-tab-pane name="4"><span slot="label">等待用户确认结果({{afterSalesTotal.beConfirm}})</span></el-tab-pane>
          <el-tab-pane name="5"><span slot="label">已完成({{afterSalesTotal.completed}})</span></el-tab-pane>
          <el-tab-pane name="6"><span slot="label">终止售后({{afterSalesTotal.applyRejected}})</span></el-tab-pane>
          <!-- <el-tab-pane name="7"><span slot="label">售后驳回({{afterSalesTotal.afterRejection}})</span></el-tab-pane> -->
          <el-tab-pane name="-1"><span slot="label">已取消({{afterSalesTotal.cancel}})</span></el-tab-pane>
        </el-tabs>
      </div>
      <el-table ref="multipleTable" v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange" fit :row-class-name="tableRowClassName">
        <el-table-column type="selection" width="50" key="1" />
        <el-table-column label="售后编号" prop="orderNum" align="center" fixed key="2">
          <template slot-scope="{row}">
            <el-link type="primary" @click="handleShow(row)">{{row.orderNum}}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="申请原因" prop="applyReason" align="center" width="100" key="3" />
        <el-table-column label="申请备注" prop="applyRamark" align="center" width="100" key="4" >
          <template slot-scope="{row}">
            <span>{{row.applyRamark||row.remarks}}</span>
          </template>
        </el-table-column>
        <el-table-column label="凭证" align="center" width="80" key="5">
          <template slot-scope="{row}">
            <template v-if="row.voucherUrl && row.voucherUrl.length">
              <el-image style="width: 50px; height: 50px" :src="row.voucherUrl[0]" :preview-src-list="row.voucherUrl"></el-image>
            </template>
            <template v-else-if="row.attachment && row.attachment.length">
              <el-image style="width: 50px; height: 50px" :src="row.attachment[0]" :preview-src-list="row.attachment"></el-image>
            </template>
            <template v-else>
              <span>暂无</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="申请商品" align="center" key="6" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <div>
              <!-- REQ-2026-234328：原来只有「商品名×数量」，补上产品规格。
                   取不到产品规格时不显示括号，避免出现「商品名()×1」这种空壳 -->
              <span v-for="(it,index) in row.goodsList" :key="index">{{it.afterGoodsName}}<template v-if="it.productSpec">（{{it.productSpec}}）</template>*{{it.afterGoodsCount}}<span v-if="index<row.goodsList.length-1">,</span></span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="申请商品总数量" prop="totalCount" align="center" width="100" key="7" />
        <el-table-column label="申请人信息" width="220" align="left" key="8">
          <template slot-scope="{ row }">
            <div class="tableDiv-txt">
              <span>姓名:{{row.customerInfo && row.customerInfo.name}}({{ row.levelName }})</span>
              <span>手机号:{{row.customerInfo && row.customerInfo.pho}}</span>
              <span v-if="row.addr && row.addr.length > 0">所属区域:
                <span v-for="(item,index) in row.addr" :key="index">{{item.regionName}}</span>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="申请时间" width="140" prop="applyTime" align="center" key="9">
          <template slot-scope="{ row }">
            {{ row.applyTime }}
          </template>
        </el-table-column>
        <!-- <el-table-column v-if="+activeName === 2" label="同意申请时间" prop="agreeTime" align="center" key="10" /> -->
        <el-table-column v-if="+activeName === 3" label="回寄商品时间" prop="deliverTime" align="center" width="140" key="11">
          <template slot-scope="{ row }">
            {{ row.deliverTime }}
          </template>
        </el-table-column>
        <el-table-column v-if="+activeName === 3" label="快递单号" prop="deliverInfo" align="center" key="12" >
          <template slot-scope="{ row }">
            <span>{{ row.deliverInfoSigned?row.deliverInfoSigned:row.deliverInfo }}</span>
          </template>
          </el-table-column>

        <el-table-column v-if="+activeName === 4" label="售后处理时间" prop="afterTime" align="center" width="140" key="13">
          <template slot-scope="{ row }">
            {{ row.afterTime }}
          </template>
        </el-table-column>
        <el-table-column v-if="+activeName === 5" label="完成时间" prop="completeTime" align="center" width="140" key="14">
          <template slot-scope="{ row }">
            {{ row.completeTime }}
          </template>
        </el-table-column>
        <el-table-column v-if="+activeName === 4 || +activeName === 5" label="售后方式" prop="afterMethod" align="center" key="15">
          <template slot-scope="{ row }">
            {{ row.afterMethod==1?'退款':'换货' }}
          </template>
        </el-table-column>
        <el-table-column label="售后来源" prop="source" align="center" key="30">
          <template slot-scope="{ row }">
            {{ row.source == 1?'APP用户提交':(row.source == 2?'待认领售后订单':'') }}
          </template>
        </el-table-column>
        <el-table-column label="是否活动商品" align="center" key="64">
          <template slot-scope="{ row }">
            <span>{{ row.isActivityAfter ? '活动商品' : '普通商品' }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="+activeName === 4 || +activeName === 5" label="退款金额" prop="refundMoney" align="center" key="16" />
        <el-table-column v-if="+activeName === 4 || +activeName === 5" label="换货商品数量" prop="exchangeNum" align="center" key="17" />
        <el-table-column v-if="+activeName === 4 || +activeName === 5" label="补差价金额" prop="repairMoney" align="center" key="18" />
        <el-table-column label="支付明细" v-if="+activeName === 5" prop="orderNo" align="center" key="19" />
        <el-table-column label="发货状态" v-if="+activeName === 5" align="center" key="20">
          <template slot-scope="{ row }">
            {{row.deliverTime?'已发货':'待发货'}}
          </template>
        </el-table-column>
        <el-table-column label="驳回原因" v-if="+activeName === 3" prop="rejectSignedReason" align="center" key="21" />
        <el-table-column label="退回原因" v-if="+activeName === 31" prop="rejectSolutionReason" align="center" key="60" />
        <el-table-column label="退回原因" v-if="+activeName === 2" prop="rejectReason" align="center" key="23" fixed="right" />

        <!-- <block>
          <el-table-column label="驳回类型" v-if="+activeName === 7" prop="rejectState" align="center" key="25">
            <template slot-scope="{ row }">
              {{row.rejectState === 1?'平台驳回':(row.rejectState === 2?'未支付':(row.rejectState === 3?'':'未确认'))}}
            </template>
          </el-table-column>
          <el-table-column label="处理结果" v-if="+activeName === 7" prop="afterMethod" align="center" key="26">
            <template slot-scope="{ row }">
              {{row.rejectState === 1?'':(row.afterMethod === 1?'退款':(row.afterMethod === 2?'换货':''))}}
            </template>
          </el-table-column>
        </block> -->
        <el-table-column label="操作人" prop="operatePO.realName" align="center" key="28" v-if=" +activeName != 2 && +activeName != 42 && +activeName != 31" />
        <el-table-column label="审核人" prop="regionalApprovalByName" align="center" key="61" v-if="+activeName === 42" />
        <el-table-column label="审核时间" align="center" key="62" v-if="+activeName === 42">
          <template slot-scope="{ row }">{{ row.regionalApprovalTime }}</template>
        </el-table-column>
        <el-table-column label="操作人" prop="ceoApprovalByName" align="center" key="63" v-if="+activeName === 31" />
        <el-table-column label="操作" align="center" width="230" v-if=" +activeName === 3 || +activeName === 31 || +activeName === 5|| +activeName === 4 ||+activeName === 2" key="29" fixed="right">
          <template slot-scope="{ row }">
            <template v-if=" +activeName === 2 ">
              <el-button type="text" @click="handleReturnToLogistics(row,1)">填写物流单号</el-button>
              
            </template>
            <template v-if=" +activeName === 3 ">
              <el-button type="text" @click="handleAddOrder(row)" v-hasPermi="['order:afterorder:state']">同意/并确认收货</el-button>
              <el-button type="text" @click="handleEndAfterSales(row)" v-hasPermi="['order:afterorder:state']">终止售后</el-button>
              <el-button type="text" @click="handleReturnToLogistics(row,2)">修改物流单号</el-button>
            </template>
            <!-- <template v-if=" +activeName === 3 ">
              <el-button type="text" @click="handleAddTrackingNumber(row.id)" v-hasPermi="['order:afterorder:state']">同意</el-button>
              <el-button type="text" @click="handleUpOrder(row.id)" v-hasPermi="['order:afterorder:state']">{{+activeName === 1?'驳回':'拒绝'}}</el-button>
            </template> -->
            <template v-if="+activeName === 31">
              <el-button type="text" @click="handleAfterSales(row)">处理售后</el-button>
              <el-button type="text" @click="handleAfterReject(row)">驳回</el-button>
              <el-button type="text" @click="handleAfterchangeUser(row)" v-hasPermi="['order:afterorder:changeUser']">更换申请人</el-button>
              <el-button type="text" v-if="row.ceoApprovalBy" @click="handleEndAfterSales(row)">终止售后</el-button>
            </template>
            <template v-if="+activeName === 3 || +activeName === 5">
              <el-button type="text" @click="lookLogistics(row)" v-hasPermi="['order:afterorder:logistics']">查看物流</el-button>
            </template>

            <template v-if="+activeName === 4">
              <el-button type="text" @click="handleAfterafterRevokeSolution(row)"  v-hasPermi="['order:afterorder:revoke']" >撤回售后</el-button>
            </template>

            <template v-if="+activeName === 41 || +activeName === 42">
              <el-button type="text" @click="handleEndForAudit(row)">终止售后</el-button>
            </template>

          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>

    <!-- 添加售后 -->
    <order-add ref="orderAdd" @created="doQueryList({})" />
    <logistics-details-vue ref="logisticsDetailsVue" />
    <after-sales-vue ref="afterSalesVue" @created="doQueryList({})" />

    <!-- 变更申请人弹窗 -->
    <el-dialog
      title="更换申请人"
      :visible.sync="changeUserDialogVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <el-form :model="changeUserForm" label-width="120px">
        <el-form-item label="更换申请人：">
          <el-select
            v-model="changeUserForm.customerId"
            placeholder="请选择申请人"
            filterable
            remote
            :remote-method="searchChangeUser"
            :loading="userListLoading"
            clearable
            style="width: 100%"
          >
            <el-option
              v-for="item in userList"
              :key="item.id"
              :label="`${item.name}-${item.customerLevelName}-${item.pho}`"
              :value="item.id"
            >
              <span>{{ item.name }}-{{ item.customerLevelName }}-{{ item.pho }}</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="changeUserDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmChangeUser">确认</el-button>
      </div>
    </el-dialog>
    <!-- 添加运单号 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" :before-close="handleClose">
      <el-form v-loading="fullscreenLoading" ref="form" :model="dialogQuery" label-width="100px" label-position="right" class="dialogDiv">
       <!-- <el-form-item label="快递公司">
          <el-select v-model="dialogQuery.deliveryOptionsId" placeholder="请选择" clearable size="small">
            <el-option v-for="(it,idx) in deliveryList" :key="idx" :label="it.name" :value="it.id"></el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item label="快递单号">
          <el-input 
            v-model="dialogQuery.orderNum" 
            placeholder="请输入快递单号" 
            clearable 
            size="small"
            @input="validateOrderNum"
            :class="{ 'is-error': orderNumError }"
          />
          <div v-if="orderNumError" class="el-form-item__error">运单号只能包含数字和英文字母</div>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog" size="mini">取消</el-button>
          <el-button type="primary" @click="addLogisticsNumber" size="mini">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 多个物流单号弹窗 -->
    <el-dialog
      title="物流单号列表"
      :visible.sync="logisticsListDialogVisible"
      width="600px"
    >
      <el-table :data="logisticsList" style="width: 100%">
        <el-table-column prop="num" label="物流单号" align="center"></el-table-column>
        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="{ row }">
            <el-button type="text" @click="viewSingleLogistics(row)">查看物流</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="logisticsListDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import orderAdd from './add';
import goodsOrderApi from '@/api/order/goodsOrder'
import sysAddrApi from '@/api/sys/sysAddr'
import Pagination from '@/components/Pagination'
import { Subtr } from '@/utils/index'
import logisticsDetailsVue from '@/views/common/logisticsDetails.vue';
import afterSalesVue from './afterSales.vue';
// 省市区路径的级间分隔符，与后端 CustomerAddrPathQO.PATH_SEPARATOR 一致；不能用逗号（BUG-2026-284617，见 toAddrPaths）
const ADDR_PATH_SEPARATOR = '-'

export default {
  components: {
    orderAdd,
    Pagination,
    logisticsDetailsVue,
    afterSalesVue
  },
  data() {
    return {
      query: {
        pageNo: 1,
        pageSize: 10,
        state: 1,

      },
      // REQ-2026-842631 客户所属省市区（多选）
      addrPaths: [],
      addressList: [],
      cascaderProps: {
        label: 'regionName',
        value: 'regionCode',
        children: 'child',
        checkStrictly: true,
        multiple: true
      },

      activeName: "2",
      listLoading: true,
      list: [],
      total: 0,
      orderTitle: 0,
      fetchList: [],
      dateTime: '',
      selectItems: [],
      afterSalesTotal: null,
      // 变更申请人相关
      changeUserDialogVisible: false,
      changeUserForm: {
        customerId: null,
        afterOrderId: null
      },
      dialogQuery: {
        deliveryOptionsId: undefined,
        orderNum: undefined,
      },
      userList: [],
      userListLoading: false,
      currentChangeRow: null,
      // 添加运单号相关
      dialogVisible: false,
      fullscreenLoading: false,
      deliveryList: [],
      dialogItem: null,
      orderNumError: false,
      dialogType: 1, // 1-添加运单号，2-修改运单号
      // 多个物流单号相关
      logisticsListDialogVisible: false,
      logisticsList: [],
      currentLogisticsPho: '' // 当前查看物流的手机号后缀
    };
  },
  computed: {
    dialogTitle() {
      return this.dialogType === 1 ? '添加运单号(多个运单号以英文逗号分隔)' : '修改运单号(多个运单号以英文逗号分隔)';
    }
  },
  created() {
    let { name } = this.$route.query;
    if (name) this.query.name = name
    this.getFetchList();
    this.getAddressList();  // REQ-2026-842631 省市区级联数据
    this.doQueryList({ pageNo: 1 });
  },
  methods: {
    // handleExport() {
    //   this.$message && this.$message.info('导出功能开发中')
    // },
    tableRowClassName({ row, rowIndex }) {
      if (row.rejectSignedTime && (+this.activeName === 31 || +this.activeName === 3)) {
        return 'warning-row';
      }
      return '';
    },
    handleAfterSales(row) {
      this.$refs.afterSalesVue.handleAddOrder(row)
    },
  
    lookLogistics(row) {
      let { pho } = row.customerInfo || {};
      let str = pho ? `:${pho.trim().slice(-4)}` : '';
      const deliverInfo = (row.deliverInfoSigned || row.deliverInfo || '').toString().trim();
      
      // 统一处理：无论单个还是多个物流单号，都显示弹窗
      if (deliverInfo) {
        // 按逗号分割物流单号（即使只有一个，也分割）
        const logisticsNums = deliverInfo.split(',').map(num => num.trim()).filter(num => num && !num.includes(','));
        if (logisticsNums.length > 0) {
          this.logisticsList = logisticsNums.map(num => ({
            num: num, // 确保每个都是单个物流单号，不包含逗号
            phoSuffix: str
          }));
          this.currentLogisticsPho = str;
          this.logisticsListDialogVisible = true;
        } else {
          this.$message.warning('物流单号格式错误');
        }
      } else {
        this.$message.warning('暂无物流信息');
      }
    },
    // 查看单个物流（从弹窗中）
    viewSingleLogistics(row) {
      // 确保只获取单个物流单号，去除可能的逗号和其他字符
      let logisticsNum = (row.num || '').toString().trim();
      // 如果包含逗号，只取第一个
      if (logisticsNum.includes(',')) {
        logisticsNum = logisticsNum.split(',')[0].trim();
      }
      const phoSuffix = row.phoSuffix || this.currentLogisticsPho || '';
      if (logisticsNum) {
        // 只传递单个物流单号，不包含逗号
        this.$refs.logisticsDetailsVue.handleShow(logisticsNum + phoSuffix);
      } else {
        this.$message.warning('物流单号为空');
      }
    },
    getFetchList() {
      goodsOrderApi.fetchList({}).then((data) => {
        this.fetchList = data.data;
      })
    },
    getAfterTotalNum() {
      let params = JSON.parse(JSON.stringify(this.query))
      delete params.pageNo
      delete params.pageSize
      delete params.state
      goodsOrderApi.getAfterTotal(params).then((res) => {
        let { data } = res;
        if (!data) {
          var obj = {
            audit: 0,
            sentBack: 0,
            pendingReceipt: 0,
            beConfirm: 0,
            completed: 0,
            applyRejected: 0,
            afterRejection: 0,
            cancel:0,
            pendingRegional:0,
            pendingCeo:0,
          }
          data = obj;
        }
        this.afterSalesTotal = data;
      })
    },
    calcQuery() {
      let { searchTimeType } = this.query
      if (searchTimeType && this.dateTime && this.dateTime.length > 0) {
        this.query.startTime = this.dateTime[0]
        this.query.endTime = this.dateTime[1]
      } else {
        this.query.startTime = undefined
        this.query.endTime = undefined
      }
      // REQ-2026-842631：省市区在这里拼，不在 handleQuery 里 ——
      // 翻页走的是 doQueryList 而不是 handleQuery，拼在 handleQuery 里会导致
      // "第一页筛过、翻到第二页条件就丢了"（验收第 8 条专门验这个）。
      this.query.addrPaths = this.toAddrPaths(this.addrPaths)
    },
    /**
     * 把多选级联的值编码成**路径字符串数组**：`['51', '53-5301', '51-5101-510107']`。
     *
     * ⚠️ 级间分隔符是 `-` 不是逗号（BUG-2026-284617）：只选一个市时请求里 addrPaths 只有一个值，
     *    Spring 把单值含逗号的 `53,5301` 按逗号拆成 ['53','5301'] 两条整省路径，市级丢了、退化成整省
     *    （昆明市期望 97 实得 443）；选两个以上时不拆，所以时好时坏。后端 CustomerAddrPathQO.PATH_SEPARATOR 同字符。
     *
     * ⚠️ 与 export/list/afterOrder.vue 的 toAddrPaths **是同一套口径**，改一处要改两处。
     *
     * ⚠️ **不能返回对象数组**。列表接口是 GET，全局序列化器是
     *    `qs.stringify(params, {arrayFormat:'repeat'})`，repeat 格式不带下标，
     *    对象数组会被拍成
     *      addrPaths[provinceCode]=51&addrPaths[provinceCode]=53&addrPaths[cityCode]=5301
     *    —— "哪个市属于哪个省"在 URL 里就丢了，等于回到"三个扁平袋子"那个 bug。
     *    编成字符串后是 addrPaths=51&addrPaths=53-5301，GET/POST 都干净。
     *
     * ⚠️ **也不能只在这一个请求上换序列化器**：那会让这个接口的参数风格和全站不一致，
     *    下一个人改这里很容易踩回去。更不能改 request.js 的全局 arrayFormat（影响所有列表页）。
     *
     * ⚠️ `checkStrictly: true` 下路径长度 1~3 不固定，按长度逐级取；空路径跳过。
     */
    toAddrPaths(paths) {
      if (!Array.isArray(paths) || paths.length === 0) return undefined
      const result = []
      paths.forEach(path => {
        if (!Array.isArray(path) || path.length === 0) return
        const codes = []
        for (let i = 0; i < path.length && i < 3; i++) {
          if (path[i] == null || path[i] === '') break
          codes.push(String(path[i]))
        }
        if (codes.length) result.push(codes.join(ADDR_PATH_SEPARATOR))
      })
      return result.length ? result : undefined
    },
    /** 地区树：children 为空数组时置 undefined，否则级联器会画出一个空的下一级 */
    formatCascaderData(data) {
      for (let i = 0; i < data.length; i++) {
        if (!data[i].child || data[i].child.length < 1) {
          data[i].child = undefined
        } else {
          this.formatCascaderData(data[i].child)
        }
      }
      return data
    },
    getAddressList() {
      sysAddrApi.getAddressTreeList().then(({ data }) => {
        this.addressList = this.formatCascaderData(data)
      })
    },

    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.calcQuery()
      this.getAfterTotalNum();
      this.query.state = +this.activeName
      this.listLoading = true
      return goodsOrderApi.getlist(this.query)
        .then(res => {
          let data = res.data;
          if (data.list.length) {
            data.list.forEach(it => {
              it.voucherUrl = it.voucherUrl ? it.voucherUrl.split(',') : [];
              it.attachment = it.attachment ? it.attachment.split(',') : [];
              it.afterCount = 0;
              it.goodsList && it.goodsList.forEach(aa => {
                it.afterCount = Subtr(it.afterCount, -aa.goodsCount)
              })
            })
          }
          this.list = data.list;
          this.$nextTick(() => { this.$refs.multipleTable.doLayout(); })
          this.total = data.total;
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    // 点击搜索
    handleQuery() {
      this.doQueryList({ pageNo: 1 });
    },
    // 重置
    handleFilter() {
      this.query = {};
      this.dateTime = [];
      // REQ-2026-842631：级联的值不在 query 里，必须单独清。
      // 漏了的表现是"点重置后筛选框还显示着选中的地区，但列表已经是全量" —— 界面与数据不一致。
      this.addrPaths = [];
      this.query.state = +this.activeName;
      this.doQueryList({ pageNo: 1, pageSize: 10 });
    },
    // 切换订单类型
    handleClick() {
      this.doQueryList({ pageNo: 1 })
    },
    handleExport() {
      this.$router.push("/export/list?code=ExportOrderAfterExport")
    },
    // 添加售后
    handleAddOrder(row) {
      this.$refs.orderAdd.handleAddOrder(row);
    },
    changeShow() {
      this.showMore = !this.showMore;
    },
    beforeHandleCommand(row, command) {
      return {
        row: row,
        command: command,
      };
    },
    handleCommand(e) {
      console.log(e)
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择订单')
        return
      }
      let ids = this.selectItems.map(row => row.id);
      let allId = ids.join('');
      if (e.command == 1) {  //同意
        this.handleAddTrackingNumber(allId);
      } else {
        this.handleUpOrder(allId);
      }

    },
    selectionChange(val) {
      console.log(val)
      this.selectItems = val;
    },
    sortChange({ column, prop, order }) {
      // 排序变化处理，如果需要排序功能可以在这里实现
      // console.log('排序变化:', { column, prop, order })
    },
    handleEndAfterSales(row) {
      this.$common.confirm('是否确认终止售后!', '提示',).then(() => goodsOrderApi.afterEnd({ id: row.id }))
        .then(() => {
          this.$common.showMsg('success', '操作成功');
          this.doQueryList({ pageNo: 1 });
        })
    },
    handleEndForAudit(row) {
      this.$common.confirm('是否确认终止售后？', '提示').then(() => goodsOrderApi.endForAudit({ id: row.id }))
        .then(() => {
          this.$common.showMsg('success', '操作成功');
          this.doQueryList({ pageNo: 1 });
        })
    },
    // 同意
    handleAddTrackingNumber(ids) {
      if (+this.activeName == 3) return this.handleAddOrder(ids)
      this.$common.confirm('是否确认同意该申请？', '提示',).then(() => goodsOrderApi.updateOrderAfterState({ afterIdStr: ids, state: 2 }))
        .then(() => {
          this.$common.showMsg('success', '操作成功');
          this.doQueryList({ pageNo: 1 });
        })
    },
    //驳回售后处理
    handleAfterReject(row) {
      this.$prompt('驳回售后处理', {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPlaceholder: "驳回数据后会返回待收货状态",
      }).then(({ value }) => goodsOrderApi.afterSignedReject({ id: row.id, rejectReason: value }))
        .then(() => {
          this.$common.showMsg('success', '操作成功');
          this.doQueryList({ pageNo: 1 });
        });
    },
    //变更申请人
    handleAfterchangeUser(row){
      this.currentChangeRow = row;
      this.changeUserForm.afterOrderId = row.id;
      this.changeUserForm.customerId = null;
      this.userList = [];
      // 显示当前申请人信息
      if (row.customerInfo) {
        const currentUser = {
          id: row.customerInfo.id,
          name: row.customerInfo.name,
          pho: row.customerInfo.pho,
          customerLevelName: row.levelName || ''
        };
        this.userList = [currentUser];
        this.changeUserForm.customerId = row.customerInfo.id;
      }
      this.changeUserDialogVisible = true;
    },
    // 搜索变更用户
    searchChangeUser(query) {
      if (query !== '') {
        this.userListLoading = true;
        goodsOrderApi
          .getUserList({
            state: 1,
            isDeparted: 0,
            nameOrPho: query,
            pageNo: 1,
            pageSize: 100
          })
          .then(res => {
            let { list } = res.data;
            let arr = [];
            list &&
              list.forEach(item => {
                let { id, name, pho } = item.customer;
                arr.push({
                  id,
                  name,
                  pho,
                  customerLevelName: item.customerLevel.name
                });
              });
            // 如果当前选中的用户不在搜索结果中，保留它
            if (this.changeUserForm.customerId) {
              const currentUser = this.userList.find(u => u.id === this.changeUserForm.customerId);
              if (currentUser && !arr.find(u => u.id === currentUser.id)) {
                arr.unshift(currentUser);
              }
            }
            this.userList = arr;
          })
          .finally(() => {
            this.userListLoading = false;
          });
      } else {
        // 如果搜索为空，保留当前选中的用户
        if (this.changeUserForm.customerId && this.userList.length > 0) {
          const currentUser = this.userList.find(u => u.id === this.changeUserForm.customerId);
          this.userList = currentUser ? [currentUser] : [];
        } else {
          this.userList = [];
        }
      }
    },
    // 确认变更申请人
    confirmChangeUser() {
      if (!this.changeUserForm.customerId) {
        this.$message.warning('请选择申请人');
        return;
      }
      if (!this.changeUserForm.afterOrderId) {
        this.$message.warning('订单信息错误');
        return;
      }
      
      this.$common.confirm('确认更换申请人？', '提示').then(() => {
        goodsOrderApi.changeUser({
          id: this.changeUserForm.afterOrderId,
          customerId: this.changeUserForm.customerId
        }).then(() => {
          this.$common.showMsg('success', '操作成功');
          this.changeUserDialogVisible = false;
          this.doQueryList({ pageNo: 1 });
        }).catch(err => {
          this.$message.error(err.message || '操作失败');
        });
      });
    },
    //撤回售后
    // handleAfterafterRevokeSolution(row) {
    //   this.$common.confirm('撤回售后处理', {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消"
    //   }).then(() => goodsOrderApi.afterrevokeSolution({ id: row.id }))
    //     .then(() => {
    //       this.$common.showMsg('success', '操作成功');
    //       this.doQueryList({ pageNo: 1 })
    //     })
    // },
    handleAfterafterRevokeSolution(row) {
      this.$prompt('撤回售后处理', {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPlaceholder: "撤回售后处理会返回待处理售后状态",
      }).then(({ value }) => goodsOrderApi.afterrevokeSolution({ id: row.id ,remark: value}))
        .then(() => {
          this.$common.showMsg('success', '操作成功');
          this.doQueryList({ pageNo: 1 })
        })
    },
    //查询加盟商，合作商用户列表
    getUserList(query) {
      goodsOrderApi
        .getUserList({
          state: 1,
          isDeparted: 0,
          nameOrPho: query,
          pageNo: 1,
          pageSize: 100
        })
        .then(res => {
          let { list } = res.data;
          let arr = [];
          list &&
            list.forEach(item => {
              let { id, name, pho } = item.customer;
              arr.push({
                id,
                name,
                pho,
                customerLevelName: item.customerLevel.name
              });
            });
          this.userList = arr;
        });
    },
    //驳回
    handleUpOrder(ids) {
      let state = +this.activeName == 1 ? 6 : 7;
      this.$prompt(+this.activeName === 1 ? '驳回申请' : '售后驳回', {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPlaceholder: "请输入驳回原因",
      }).then(({ value }) => goodsOrderApi.updateOrderAfterState({ afterIdStr: ids, state, remark: value }))
        .then(() => {
          this.$common.showMsg('success', '操作成功');
          this.doQueryList({ pageNo: 1 });
        });
    },
    // 查看详情
    handleShow(row) {
      row.activeName = +this.activeName
      this.$emit('handleShow', row, 2)
    },
    // 添加运单号
    openDialog(row) {
      this.dialogVisible = true;
      this.dialogItem = row;
      this.dialogQuery.orderNum = undefined;
      this.orderNumError = false;
    },
    // 关闭对话框
    handleClose(done) {
      this.closeDialog();
      if (done) done();
    },
    closeDialog() {
      this.dialogVisible = false;
      this.deliveryList = [];
      this.dialogItem = null;
      this.fullscreenLoading = false;
      this.dialogQuery.deliveryOptionsId = undefined;
      this.dialogQuery.orderNum = undefined;
      this.orderNumError = false;
      this.dialogType = 1;
    },
    // 验证运单号格式
    validateOrderNum(value) {
      if (!value) {
        this.orderNumError = false;
        return;
      }
      // 运单号只能包含数字和英文字母
      const pattern = /^[a-zA-Z0-9,]+$/;
      this.orderNumError = !pattern.test(value);
    },
    addLogisticsNumber() {
      let { deliveryOptionsId, orderNum } = this.dialogQuery
      if (this.fullscreenLoading) return;
      // if (deliveryOptionsId == undefined) return this.$message({ message: '请选择快递公司!' });
      if (orderNum == undefined) return this.$message({ message: '请填写运单号!' });
      if (this.orderNumError) return this.$message({ message: '运单号格式不正确!' });
      // let find = this.deliveryList.find(item => item.id === deliveryOptionsId)
      // 构造参数：deliverInfo 为 JSON 字符串格式
      // const deliverInfo = JSON.stringify([{
      //   name: find.name,
      //   num: orderNum
      // }]);
      let obj = {
        id: this.dialogItem.id
      }
      this.fullscreenLoading = true;
      // 根据 dialogType 调用不同的方法
      const apiMethod = this.dialogType === 1 ? goodsOrderApi.returnToLogistics : goodsOrderApi.signedLogistics;
      if(this.dialogType === 1){
        obj.deliverInfo=orderNum
      }else if(this.dialogType === 2){
        obj.deliverInfoSigned=orderNum
      }
  
      apiMethod(obj).then(res => {
        this.$message({ type: 'success', message: '操作成功!' });
        this.closeDialog();
        this.doQueryList({ pageNo: 1 });
      }).finally(() => {
        this.fullscreenLoading = false;
      })
    },
    // 待寄回端口支持后台填写物流单号
    handleReturnToLogistics(row,type) {
      this.dialogType = type;
      this.openDialog(row);
    },
    // 签收物流
    handleSignedLogistics(row) {
      this.$common.confirm('签收物流', {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => goodsOrderApi.signedLogistics({ id: row.id }))
        .then(() => {
          this.$common.showMsg('success', '操作成功');
          this.doQueryList({ pageNo: 1 });
        })
    },
  },
};
</script>
<style>
.tableDiv-txt {
  display: flex;
  flex-direction: column;
}
.warning-row {
  background-color: #fdecec !important;
}
</style>
